import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import ReactTable from "../../AppComponent/Table";
import {
  StetheAttendanceExportActions,
  setAttendanceExportgetlistActions,
  SetUserREtrieveActions,
} from "../../../Redux/Slice";
import AttedanceExport from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";

const AttendanceExpor = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [withoutData, setwithoutData] = useState(true);
  const [Dob, setDob] = useState(["D.O.J", "D.O.B", "Designation"]);

  // const getCurrentAndNextMonthDates = () => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const currentYear = currentDate.getFullYear();
  //   const currentdate = currentDate.getDate();

  //   const nextMonthDate = new Date(currentYear, currentMonth - 1); // Subtract 1 from currentMonth
  //   nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //   const currentMonthFormatted = `${currentYear}-${String(
  //     currentMonth
  //   ).padStart(2, "0")}-${currentdate}`;

  //   // Get the last date of the next month
  //   const nextMonthLastDate = new Date(
  //     nextMonthDate.getFullYear(),
  //     nextMonthDate.getMonth() + 1,
  //     0
  //   );
  //   const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(
  //     nextMonthDate.getMonth() + 1
  //   ).padStart(2, "0")}-${nextMonthLastDate.getDate()}`;

  //   return {
  //     currentMonth: currentMonthFormatted,
  //     nextMonth: nextMonthFormatted,
  //   };
  // };

  // Usage

  //   const getCurrentAndNextMonthDates = () => {
  //     const currentDate = new Date();
  //     const currentMonth = currentDate.getMonth() + 1;
  //     const currentYear = currentDate.getFullYear();
  //     const currentdate = currentDate.getDate();

  //     const nextMonthDate = new Date(currentYear, currentMonth); // No need to subtract 1 from currentMonth
  //     nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //     const currentMonthFormatted = `${currentYear}-${String(
  //       currentMonth
  //     ).padStart(2, "0")}-${currentdate}`;

  //     // Get the last date of the next month
  //     const nextMonthLastDate = new Date(
  //       nextMonthDate.getFullYear(),
  //       nextMonthDate.getMonth() + 1,
  //       0
  //     );
  //     const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(
  //       nextMonthDate.getMonth() + 1
  //     ).padStart(2, "0")}-${nextMonthLastDate.getDate()}`;

  //     return {
  //       currentMonth: currentMonthFormatted,
  //       nextMonth: nextMonthFormatted,
  //     };
  // };

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();
  console.log(startDatemon, endDatemon, "startDate and endDate");

  // var { currentMonth, nextMonth } = getCurrentAndNextMonthDates();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  console.log("nextmonths", data);

  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;

    //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Data, setdatas] = useState({
    month: months,
    year: date.getFullYear(),
  });

  const [monthYearset, setMonthYear] = useState("");

  ////------month and year based filters-------------------------------
  const handleChange = (e) => {
    setMonthYear(e.target.value);
    const months = new Date(e.target.value);
    // months.getMonth()
    console.log(months.getMonth() + 1, "months", months.getFullYear());
    const selectedmonth =
      months.getMonth() < 10
        ? `0${months.getMonth() + 1}`
        : months.getMonth() + 1;
    setYearMpnth(`${months.getFullYear()}-${selectedmonth}`);
    console.log(e.target.value, "weurweydsfsd", selectedmonth);
    setdatas({
      ...Data,
      month: selectedmonth,
      year: months.getFullYear(),
    });
  };

  const Options = [
    {
      id: 1,
      value: "day",
      label: "DAY",
    },
    {
      id: 2,
      value: "time",
      label: "TIME",
    },
  ];

  //   -----Attendance---export get list call
  // useEffect(()=>{
  //     if(state.clientDetailsCall
  //         .ActiveForUserProfile == 4){
  //          const payload = {
  //              user:state.ClientBranchIDs.userProfileId,
  //              month: Data.month,
  //              year: Data.year,
  //          }
  //          dispatch(setAttendanceExportgetlistActions(payload))

  //     }
  // },[state.clientDetailsCall
  //     .ActiveForUserProfile , Data])

  ///---retrieve----calls-------------
  useEffect(() => {
    if (state.ClientBranchIDs.userProfileId != undefined) {
      const payload = {
        EditId: state.ClientBranchIDs.userProfileId,
      };
      dispatch(SetUserREtrieveActions(payload));
    }
  }, []);

  const columns = [
    {
      Header: "First Name",
      accessor: "first_name",
    },
    {
      Header: "Last Name",
      accessor: "last_name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_role != undefined &&
            row.row.original.user_role != null &&
            row.row.original.user_role.role != undefined ? (
              <span>{row.row.original.user_role.role}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Casual Leave",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.casual_leave != undefined ? (
              <span>{row.row.original.working_status.casual_leave}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Leave Valid date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.leave_valid_until != undefined ? (
              <span>{row.row.original.working_status.leave_valid_until}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Permission Valid date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.permission_valid_until !=
              undefined ? (
              <span>
                {row.row.original.working_status.permission_valid_until}
              </span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Personal Leave",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.working_status != undefined &&
            row.row.original.working_status != null &&
            row.row.original.working_status.personal_leave != undefined ? (
              <span>{row.row.original.working_status.personal_leave}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        if (row.row.original.created_at != null) {
          const dateString =
            row.row.original.created_at != null
              ? row.row.original.created_at
              : "";
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <span>
                {row.row.original.created_at != null ? (
                  <>
                    {`${
                      row.row.original.created_at.slice(0, 10) +
                      "  " +
                      formattedTime
                    }`}
                  </>
                ) : (
                  <p>{"----"}</p>
                )}
              </span>
            </>
          );
        } else {
          return <span>{"----"}</span>;
        }
      },
    },
  ];

  const [selectedDates, setSelectedDates] = useState([]);
  const [datestae, setdatest] = useState(false);
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  const handleDateChange = (e) => {
    if (e != null) {
      setdatest(true);
      setSelectedDates(e);
      e.forEach((newValue) => {
        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const localISOTime = new Date(newValue - tzoffset)
          .toISOString()
          .slice(0, -1);
        // handle the start and end dates here
        console.log(localISOTime);
      });
    }
  };

  console.log(formattedDates, "formattedDates");
  useEffect(() => {
    if (datestae) {
      setdata({
        ...data,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);

  const attendanceexportEmp = (e, statement, values) => {
    console.log(values, statement, e, "auysfdasdasdyasdlas");
    Swal.fire({
      title: `Are you sure, do you want to export the attendance  ${
        statement ? "based on this month to end of the  month" : ""
      }?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: "employee",
          client_id: "",
          user_id: values.user_id,
          data: values.data,
          Dob: [],
        };
        dispatch(StetheAttendanceExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  const HandleChanges = (e) => {
    //    console.log(e.target.value, "sdfsdgfweifi");

    setdata({ ...data, base_type: e.target.value });
  };

  const pagesize = (arg) => {};

  const pageindex = (arg) => {};

  const handlePrevious = (e) => {};
  const handleNext = (e) => {};
  const tochange = (e) => {};
 const GotoEnteredPage=(e)=>{};
 const openMe = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('left', '428.344px ', 'important');
    rsAnimFade.style.setProperty('top', '158.109px', 'important');   
  }
 }

 const CloseDateRange = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('display', 'none', 'important');
    // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
  }
 }

  return (
    <>
      <div
        //className="DatePicker daterangeinclientdetails"
        className="row  mt-4"
        style={{ paddingLeft: "20px", paddingRight: "20px" }}
      >
        {/* 
<div className="col-3">
                              <label style={{ marginLeft: "12px" }}>
                                <input
                                  type="checkbox"
                                  value={withoutData}
                                  onChange={(e) => {
                                    if (withoutData) {
                                      setDob([]);
                                    } else {
                                      setDob(["D.O.J", "D.O.B", "Designation"]);
                                    }

                                    setwithoutData(!withoutData);
                                  }}
                                />

                                <span style={{ marginLeft: "12px" }}>
                                  {withoutData
                                    ? "without (DOB , DOJ , Designation) Sheet will be Export"
                                    : "with (DOB, DOJ, Designation) Sheet will be Export"}
                                </span>
                              </label>
                            </div> */}

        <div className="col-3">
          <select
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "10px",
            }}
            class="form-select form-select-lg mb-3"
            aria-label=".form-select-lg example"
            name="marital_status"
            readOnly={state.NumberCounts.Editable == 1 ? true : false}
            onChange={(e) => {
              HandleChanges(e);
            }}
          >
            {Options.map((item) => (
              <option
                value={item.value}
                // selected={
                //   data.marital_status != undefined
                //     ? data.marital_status.toLowerCase() ==
                //       item.value.toLowerCase()
                //     : null
                // }
              >
                {item.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-3 mt-2 ">
          <DateRangePicker
            className="Dateranger"
            //  style={{ width: 270, padding: 10 }}
            placeholder="From-To"
            onChange={handleDateChange}
            showHeader={false}
            size="lg"
            onOpen={() => {
              openMe()
            }}
         onClose={() => {
            CloseDateRange()
               }}
            value={selectedDates}
          />
        </div>
        <div className=" col-3   mt-2 actions">
          <button
            type="button"
            class="btn Status"
             style={{display:"flex"}}
            onClick={(e) => {
              // e.stopPropagation();
              const payloads = {
                export_type: "employee",
                client_id: "",
                user_id: state.ClientBranchIDs.userProfileId,
                data: data,
              };

              if (
                startDatemon == data.from_date &&
                endDatemon == data.to_date
              ) {
                attendanceexportEmp(e, true, payloads);
              } else {
                attendanceexportEmp(e, false, payloads);
              }
            }}
          >
            Export

                               <span  className="AttendanceExportImage">
                    <img src={AttedanceExport}/>
                  </span>
          </button>
        </div>
      </div>

      <div>
        {/* <div
          style={{
            position: "absolute",
            height: "71px",
            zIndex: "1",
            width: "25%",
            display: "flex",
            justifyContent: "flex-start",
            // paddingRight: "220px",
            alignItems: "flex-start",
            flexDirection: "column",
            right: "128px",
          }}
          className="innnermontfilters"
        >
          <div style={{ display: "inline", marginTop: "6px" }}>
            <p>Month</p>
            <input
              type="month"
              value={yearAndMonth}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </div>
        </div> */}

        <ReactTable
          data={[state.UserRetrieve.userRetrireve]}
          columns={columns}
          currentPage={1}
          totalItems={10}
          pagesize={pagesize}
          dtpagesize={20}
          pageindex={pageindex}
          datacount={10}
          onPrevious={handlePrevious}
          onNextpage={handleNext}
          GotoEnteredPage={GotoEnteredPage}
      dtpageindex={1}
    
          // onChange={tochange}
          Search={true}
        />
      </div>

      {/* </div> */}
    </>
  );
};

export default AttendanceExpor;
